import React from 'react';
import ReusableDemoPage from "../ReusableDemoPage";
import { magicleafConfig } from '../demoConfigs';

const MagicleafDemo = () => {
  return <ReusableDemoPage config={magicleafConfig} />;
};

export default MagicleafDemo;